export const RegistrationStatus = {
  NotRegistered: 0,
  RegisteredNotVerified: 1,
  RegisteredVerified: 2,
  PasswordResetRequested: 3,
  Unknown: 4,
} as const

export type RegistrationStatusValue =
  (typeof RegistrationStatus)[keyof typeof RegistrationStatus]

export type BaseResponse<T> = {
  data: T | null
  registrationStatus: RegistrationStatusValue
  isSuccess: boolean
  needsToLogin: boolean
}
